import { render } from "./OffCanvasMenu.vue?vue&type=template&id=e8c1df32"
import script from "./OffCanvasMenu.vue?vue&type=script&lang=js"
export * from "./OffCanvasMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__